import { Core } from "@/core/Core";

export default {

  /* Modifiers */

  async getModifiers(context, {inventoryId, augment = 'backend'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/modifiers`, {augment, admin: true});
    } catch (e) {
      return null;
    }
  },

  async getModifier(context, {inventoryId, itemId, version, augment = 'backend'}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/modifiers/${itemId}`, {augment, version});
    } catch (e) {
      return null;
    }
  },

  async createModifier(context, {inventoryId, data, version}) {
    try{
      let query = version ? `?version=${version}` : '';
      return await Core.request("POST", `/api/inventory/${inventoryId}/modifiers${query}`, data);
    } catch (e) {
      return null;
    }
  },

  async saveModifier(context, {inventoryId, itemId, data, version}) {
    try{
      let query = version ? `?version=${version}` : '';
      return await Core.request("PUT", `/api/inventory/${inventoryId}/modifiers/${itemId}${query}`, data);
    } catch (e) {
      return null;
    }
  },


  async deleteModifier(context, {inventoryId, itemId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/modifiers/" + itemId);
    } catch(e) {
      return null;
    }
  }

}